import { FunctionComponent } from "react";
import Button from "../components/button";

interface PositionFieldProps {
  position: { camera?: [number, number, number]; target?: [number, number, number] };
  setPosition: () => void;
}

const PositionField: FunctionComponent<PositionFieldProps> = ({ position, setPosition }) => {
  return (
    <div className="p-6 border-b">
      <div className="font-bold mb-6 text-lg">Initial Position</div>
      <div className="mb-6 space-y-3">
        <div className="flex items-center">
          <div className="w-[80px]">Camera</div>
          <div className="bg-gray-100 px-4 py-1.5 flex-grow text-center">
            {!position.camera ? "Not set." : position.camera.map((v) => v.toFixed(4)).join(", ")}
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-[80px]">Target</div>
          <div className="bg-gray-100 px-4 py-1.5 flex-grow text-center">
            {!position.target ? "Not set." : position.target.map((v) => v.toFixed(4)).join(", ")}
          </div>
        </div>
      </div>
      <Button onClick={setPosition} variant="secondary" className="w-full">
        Set current position
      </Button>
    </div>
  );
};

export default PositionField;
